'use client';
import React from 'react';
import { classNames } from '@repo/ui/src/utils/classNames';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';

interface AddToCartButtonProps {
  onClick: () => void;
  disabled?: boolean;
  processing?: boolean;
  outOfStock?: boolean;
  className?: string;
}

const AddToCartButton = ({
  onClick,
  disabled,
  processing,
  outOfStock,
  className,
}: AddToCartButtonProps) => {
  const { t } = useTranslation();

  const label = () => {
    if (processing) return t('cart.addingToCartText', undefined, { default: 'Adding...' });
    if (outOfStock) return t('cart.outOfStockText', undefined, { default: 'Out of Stock' });
    return t('cart.addToCartText', undefined, { default: 'Add to Cart' });
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || processing || outOfStock}
      className={classNames(
        'w-full bg-brand-300 text-white font-bold text-base tracking-[1.92px] uppercase px-10 py-5 h-[60px] flex items-center justify-center border-0 cursor-pointer hover:bg-brand-400 transition-colors disabled:bg-neutral-300 disabled:cursor-not-allowed',
        className,
      )}
    >
      {label()}
    </button>
  );
};

export default AddToCartButton;
